import { ColumnType, THEME } from "@digitallab/grid-common-frontend-components";
import { OwcInput } from "@one/react";
import { useField } from "formik";
import { react18WorkaroundProps } from "../../../../utils/constants/react18WorkaroundProps";

export const FormInput = ({ column }: { column: ColumnType }) => {
  const [field, meta, helpers] = useField(column.name ?? "column") || [null, null, null];
  const [conditionalField] = useField(
    column?.conditionalRequired ? column.conditionalRequired.dependsOnName : "no_condition"
  );
  const isRequired =
    conditionalField.name !== "no_condition"
      ? column.conditionalRequired?.condition(conditionalField.value)
      : column.required;
  const isTouched = Boolean(meta.touched);
  return (
    <div style={{ minHeight: THEME["one-spacer-80"] }}>
      <OwcInput
        {...react18WorkaroundProps}
        style={{ width: "100%" }}
        required={column.required}
        label={`${column.label}${isRequired ? "*" : ""}`}
        name={column.name}
        onInputChange={(event: CustomEvent<string>) => helpers.setValue(event.detail)}
        onBlur={() => helpers.setTouched(true)}
        value={field.value}
        error={isTouched && !!meta.error}
        {...column.fieldProps}
      >
        <div slot="error-text">{isTouched && meta.error}</div>
        <div slot="assistive-text">{column.assistiveText}</div>
      </OwcInput>
    </div>
  );
};
